import React from 'react';
import TreeView from '@zippytech/react-toolkit/TreeView';
import '@zippytech/react-toolkit/TreeView/index.css';
import MenuNode from "./MenuNode";
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { Container } from 'react-smooth-dnd'
import { Icon, Checkbox } from "semantic-ui-react";
import { toastr } from 'react-redux-toastr';
import ChangeAccountableConfirmationModal from '../../modals/ChangeAccountableConfirmationModal';
@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext(props.name);
  }
})

class OrganizationTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      createSubTeams: true,
      openChangeAccountableConfirmationModal: false,
      associatedCommunity: null,
      managers: [],
      members: [],
      newAssignee: null,
      teamsOpt: [],
    }
  }

  componentWillReceiveProps(prevProps) {
    if(prevProps.nodes === this.props.nodes) {
      this.props.stopProcessing
    }
  }

  onSelectionChange(map) {
    if (map.node.label.props.id) {
      dispatch.initiatives.showResourecePane("Organizations");
      dispatch.initiatives.splitAt("60%");
      dispatch.initiatives.getSuborgDetailsById(map.node.label.props.id);
      dispatch.initiatives.getInviteBySubOrgAsync(map.node.label.props.id);
      dispatch.initiatives.setIdToCenterPosition(map.node.label.props.id)
    } else {
      dispatch.initiatives.showResourecePane(null);
    }
    dispatch.initiatives.setIdToCenterPosition(map.node.label.props.id)
  }
  shouldAcceptDrop(sourceContainerOptions) {
    const accessDrop = sourceContainerOptions.groupName === 'TeamCreation' || sourceContainerOptions.groupName === 'TeamMapping'

    return accessDrop
  }
  createSubTeamsSelected(e, data) {
    this.setState({ createSubTeams: data.checked });
  }
  async onDragEnd(targetTeam, result) {
    if (result.addedIndex !== null) {
      for (let community of this.props.selectedDataById.communities) {
        if (community._id.toString() === result.payload.id.toString()) {
          let subOrgObject = {
            name: community.name,
            summary: "Team has been created at the time of initiative team mapping",
            organizationId: this.props.selectedOrganisation.id,
            accountId: this.props.match.params.accountId,
            parentOrganizationId: targetTeam,
            active: true,
            slug: community.name.toLowerCase().trim()
          };
          let payload = {
            data: subOrgObject,
            subOrgChild: community.communities,
            communityId: community._id,
            organizationId: this.props.selectedOrganisation.id,
            accountUserId: this.props.user._id,
            initiativeId: this.props.selectedDataById._id,
            accountId: this.props.match.params.accountId
          }
          toastr.confirm(null,
            {
              okText: 'Create',
              component: () => (<div className="pad_20"><div><b className="clr-blue">Create Team</b><br /><br /><b className="clr-blue">{community.name}</b><br />By dropping you are creating the team in your current workspace community. You will be the default manager for the team.</div><br /><div><Checkbox defaultChecked={this.state.createSubTeams} label='Create teams for child roles?' onChange={(event, data) => this.createSubTeamsSelected(event, data)} /></div><br /> <div> Are you sure you want to create a team(s)?</div></div>),
              onOk: async () => {
                this.props.startProcessing();
                payload.createSubTeams = this.state.createSubTeams;
                await dispatch.initiatives.addSubOrganizationWithChild(payload);
                dispatch.initiatives.getTeamMappingData({ accountId: this.props.match.params.accountId, organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.props.stopProcessing, teamId: this.props.selectedDataById.teamId });
                this.props.stopProcessing();
              }
            })
        }
        for (let subCommunity of community.communities) {
          if (subCommunity._id.toString() === result.payload.id.toString()) {
            let subOrgObject = {
              name: subCommunity.name,
              summary: "Team has been created at the time of initiative team mapping",
              organizationId: this.props.selectedOrganisation.id,
              accountId: this.props.match.params.accountId,
              parentOrganizationId: targetTeam,
              active: true,

              slug: subCommunity.name.toLowerCase().trim()
            };
            let payload = {
              data: subOrgObject,
              communityId: subCommunity._id,
              initiativeId: this.props.selectedDataById._id
            }
            toastr.confirm(null,
              {
                okText: 'Create',
                component: () => (<div className="pad_20"><div><b className="clr-blue">Create Team</b><br /><br /><b className="clr-blue">{community.name} > {subCommunity.name}</b><br />By dropping you are creating the team in your current workspace community. You will be the default manager for the team.</div><br /> <div> Are you sure you want to create this team?</div></div>),
                onOk: async () => {
                  this.props.startProcessing();
                  await dispatch.initiatives.addSubOrganization(payload);
                  dispatch.initiatives.getTeamMappingData({ accountId: this.props.match.params.accountId, organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.props.stopProcessing, teamId: this.props.selectedDataById.teamId });
                  this.props.stopProcessing();
                }
              })
          }
        }
      }
    }
  }
  setManagers = (value) => {
    this.setState({ managers: value })
  }
  setMembers = (value) => {
    this.setState({ members: value })
  }
  setAssignee = (value) => {
    this.setState({ newAssignee: value })
  }
  setAssociatedCommunity = (value) => {
    this.setState({ associatedCommunity: value })
  }
  setChangeAccountableConfirmationModalOpen = () => {
    this.setState({ openChangeAccountableConfirmationModal: true })
  }
  closeChangeAccountConfirmationModal = () => {
    this.setState({ openChangeAccountableConfirmationModal: false })
  }
  render() {
    // console.log(this.props.nodes);
    let components = [];
    const thisObject = this;
    const getDataNode = function (treeData, container, depth, parentNodeId) {
      if (treeData.length === 0) {
        container.push({
          label: <Container groupName="TeamCreation" onDrop={async (e) => thisObject.onDragEnd(depth === 0 ? thisObject.props.selectedOrganisation.id : parentNodeId, e)} shouldAcceptDrop={thisObject.shouldAcceptDrop} behaviour="copy" style={{
            width: '100%', border: '1px dashed #ccc', background: "#eaeaea", padding: "5px"
          }}>Create New Team</Container>
        });
      }
      treeData.forEach((treeNode, index) => {
        let managersArray = [], membersArray = [];
        if (treeNode.members) {
          treeNode.members.forEach(member => {
            if (member.role === "Manager") {
              managersArray.push(member);
            }
            else if (member.role === "Member") {
              membersArray.push(member);
            }
          })
        }

        if (!treeNode.isLeafNode) {
          const dataNode = {
            label: (
              <MenuNode
                label={treeNode.label}
                colorTag={treeNode.tagColor}
                id={treeNode._id}
                handleDnD={thisObject.treeDnDAction}
                depth={depth}
                associatedCommunity={treeNode.associatedCommunity}
                status={0}
                disabled={true}
                element={thisObject.props.elements}
                match={thisObject.props.match}
                selectedOrganisation={thisObject.props.selectedOrganisation}
                stopProcessing={thisObject.props.stopProcessing}
                startProcessing={thisObject.props.startProcessing}
                selectedDataById={thisObject.props.selectedDataById}
                setUniqueId={thisObject.props.setUniqueId}
                managers={managersArray}
                members={membersArray}
                setManagers={thisObject.setManagers}
                setMembers={thisObject.setMembers}
                setAssignee={thisObject.setAssignee}
                setAssociatedCommunity={thisObject.setAssociatedCommunity}
                setChangeAccountableConfirmationModalOpen={thisObject.setChangeAccountableConfirmationModalOpen}
              />
            ),
            raci: treeNode.raci
          };
          if (thisObject.props.elements === 'activities')
            dataNode.icon = thisObject.props.selectedPracticeFlowActivity && thisObject.props.selectedPracticeFlowActivity.dependencies && thisObject.props.selectedPracticeFlowActivity.dependencies.indexOf(treeNode._id) !== -1 ? <Icon color='orange' name="unlinkify" /> : ""
          if (treeNode.nodes) {
            dataNode.nodes = [];
            getDataNode(treeNode.nodes, dataNode.nodes, depth + 1, treeNode._id);
          } else {
            treeNode.nodes = [];
            dataNode.nodes = [];
            getDataNode(treeNode.nodes, dataNode.nodes, depth + 1, treeNode._id);
          }

          container.push(dataNode);
          let checkRoleValidation = ((thisObject.props.selectedOrganisation.role === "workspaceOwner" && thisObject.props.selectedDataById.teamId && thisObject.props.selectedDataById.teamId.toString() === thisObject.props.selectedDataById.organizationId && thisObject.props.selectedDataById.organizationId.toString()) || depth !== 0)
          if (index === treeData.length - 1 && checkRoleValidation) {
            container.push({
              label: <Container groupName="TeamCreation" onDrop={async (e) => thisObject.onDragEnd(treeNode.parentOrganizationId, e)} shouldAcceptDrop={thisObject.shouldAcceptDrop} behaviour="copy" style={{
                width: '100%', border: '1px dashed #ccc', background: "#eaeaea", padding: "5px"
              }}>Create New Team</Container>
            });
          }
        }
      });
    };
    getDataNode(this.props.nodes, components, 0);
    let windowDimension = this.props.componentDesignerDimension;
    let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 280;
    return (
      <div style={{ maxHeight: designerHeight, minHeight: designerHeight, overflow: "auto", padding: '0 10px' }}>
        <TreeView
          className={`designerTree `}
          dataSource={components || []}
          enableSelection={true}
          enableHoverStyle={false}
          singleSelect={true}
          onSelectionChange={selectedMap => {
            this.onSelectionChange(selectedMap);
          }}
          enableKeyboardNavigation={false}
          style={{ maxHeight: designerHeight, minHeight: designerHeight, overflow: "auto" }}
        />
        {this.state.associatedCommunity && <ChangeAccountableConfirmationModal
          open={this.state.openChangeAccountableConfirmationModal}
          close={this.closeChangeAccountConfirmationModal}
          associatedCommunity={this.state.associatedCommunity}
          managers={this.state.managers}
          members={this.state.members}
          newAssignee={this.state.newAssignee}
          teamId={this.props.selectedDataById.teamId}
          selectedOrganisation={this.props.selectedOrganisation}
          initiativeId={this.props.match.params.initiativeId}
          stopProcessing={this.props.stopProcessing}
          initiativeStatus={this.props.selectedDataById.status} />}
      </div>
    );

  }
}

export default OrganizationTree;